<img nz-image *ngIf="fileUrl$ | async" [src]="fileUrl$ | async" (click)="showImage()" style="cursor: pointer;">
